import Vue from 'vue'
import Router from 'vue-router'
// import HomePage from '@/components/HomePage'
// import product1 from '@/components/product1'
// import product2 from '@/components/product2'
// import product3 from '@/components/product3'
// import product4 from '@/components/product4'
// import service from '@/components/service'
// import aboutus from '@/components/aboutus'
// import joinus from '@/components/joinus'
// import cases from '@/components/case'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: resolve => require(['@/components/HomePage'], resolve),
      meta: {
        title: '智进咨询PROWISER - Digital Transformation Agency'
      }
    },
       {
         path: '/product1',
         name: 'product1',
         component: resolve => require(['@/components/product1'], resolve),
         meta: {
           title: '智进咨询PROWISER - Social CRM'
         }
    },
    {
      path: '/product2',
      name: 'product2',
      component: resolve => require(['@/components/product2'], resolve),
      meta: {
        title: '智进咨询PROWISER - 社群营销系统'
      }
    },
    {
      path: '/product3',
    name: 'product3',
      component: resolve => require(['@/components/product3'], resolve),
      meta: {
        title: '智进咨询PROWISER - B2B营销平台'
      }
    },
    {
      path: '/product4',
      name: 'product4',
      component: resolve => require(['@/components/product4'], resolve),
      meta: {
        title: '智进咨询PROWISER - 企业营销直播系统'
      }
    },
    {
      path: '/service',
      name: 'service',
      component: resolve => require(['@/components/service'], resolve),
      meta: {
        title: '智进咨询PROWISER - 服务'
      }
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: resolve => require(['@/components/aboutus'], resolve),
      meta: {
        title: '智进咨询PROWISER - 关于我们'
      }
    },
    {
      path: '/joinus',
      name: 'joinus',
      component: resolve => require(['@/components/joinus'], resolve),
      meta: {
        title: '智进咨询PROWISER - 加入我们'
      }
    },
    {
      path: '/cases',
      name: 'cases',
      component: resolve => require(['@/components/case'], resolve),
      meta: {
        title: '智进咨询PROWISER - 案例'
      }
    }

  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js